// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11fPh","buttons":"Footer_buttons__1rOpW"};